import { fetchMachine } from './webtipMachine';
import { interpret } from 'xstate';

function WebtipMainViewController($scope, userViewService, rmmDataFetch, __env) {
  const ctrl = this;
  const env = __env;
  /**
  * Filters
  */
  ctrl.sync = "";
  ctrl.filterItems = {
    signals: [],
    sources: [],
    trains: [],
    fleets: [],
  };
  ctrl.selectedFilters = {
    signals: [],
    sources: [],
    trains: [],
    fleets: [],
  };
  /**
   * Series
   */
  $scope.data = {
    digitalSignals: [],
    analogSignals: [],
  };
  /**
   * Initialization
   */
  ctrl.$onInit = async () => {
    const currentDate = DateTime.utc().startOf('minute');
    ctrl.dates = {
      startDate: currentDate.minus({days: 1}).toJSDate(),
      endDate: currentDate.toJSDate(),
    };
    ctrl.datesChanged = false;

    ctrl.webtipMachine = interpret(fetchMachine({
      fetchAll: rmmDataFetch.all
    }), { devTools: true });
    ctrl.webtipMachine.onTransition(async state => {
      if (state.value === 'fetchData') {
        ctrl.loading = true;
        ctrl.selectedFilters.sources = state.context && state.context.filters && state.context.filters.sources || [];
        ctrl.selectedFilters.trains = state.context.filters.trains;
      }
      if (state.value === 'done') {
        const { trains, fleets, sources, signalNames: signalNames = { ANALOG: [], DIGITAL: [], signalNameDisplayOrder: [] }, data = {} } = state.context.data;
        ctrl.loading = false;
        ctrl.filterItems.trains = trains;
        ctrl.filterItems.fleets = fleets;
        ctrl.filterItems.sources = sources;

        const signals = [];
        const lowercaseSignalNames = {
          ANALOG: signalNames.ANALOG ? signalNames.ANALOG.map(signal => signal.toLowerCase()) : [],
          DIGITAL: signalNames.DIGITAL ? signalNames.DIGITAL.map(signal => signal.toLowerCase()) : []
        };

        (signalNames.signalNameDisplayOrder || []).forEach(DATA_FIELD_NAME => {
          const name = DATA_FIELD_NAME.replace(" ", "");
          if (lowercaseSignalNames.ANALOG.includes(name.toLowerCase())) {
            signals.push({ name, iconClass: 'fa-chart-line' });
          } else if (lowercaseSignalNames.DIGITAL.includes(name.toLowerCase())) {
            signals.push({ name, iconClass: 'fa-toggle-off' });
          }
        });

        ctrl.filterItems.signals = signals;
        $scope.digitalSignals = signalNames.DIGITAL;
        $scope.analogSignals = signalNames.ANALOG;

        if (data.digitalSignals) {
          $scope.data.digitalSignals = Object.keys(data.digitalSignals).length > 0 ? data.digitalSignals : [];
        } else {
          $scope.data.digitalSignals = [];
        }
        $scope.data.analogSignals = data.analogSignals || [];
        $scope.reduced = data.dataTableUsed === 'YEARLY' || data.dataTableUsed === 'MONTHLY' || data.dataTableUsed === 'WEEKLY' || data.dataTableUsed === 'DAILY';
      }
    });
    ctrl.webtipMachine.start();

    ctrl.updateSelectedTime();
    userViewService.setView('webtip');

    // This workaround is used to blur input element when a chart is clicked since highcharts would otherwise block onblur
    // event with preventDefault: https://github.com/highcharts/highcharts/issues/4606
    Highcharts.Pointer.prototype.onContainerMouseDown = function (e) {
      e = this.normalize(e);
      this.zoomOption(e);
      this.dragStart(e);
    };

    ctrl.hasStaffCar = env.profile === 'QR';
    ctrl.loading = false;
    window.onresize = ctrl.refreshSeriesOnCharts;
  };

  ctrl.setDatesChanged = () => {
    ctrl.datesChanged = true;
  };

  const setAndFetch = (event) => {
    this.webtipMachine.send(event);
    this.webtipMachine.send('FETCH_DATA');
  };

  ctrl.selectSignal = async (selected) => {
    ctrl.selectedFilters.signals = selected;
    setAndFetch({ type: 'SET_SIGNALS', signalNames: selected });
  };
  ctrl.selectSource = async (selected) => {
    ctrl.selectedFilters.sources = selected;
    setAndFetch({ type: 'SET_SOURCES', sources: selected });
  };
  ctrl.selectFleet = async (selected) => {
    ctrl.selectedFilters.fleets = selected;
    setAndFetch({ type: 'SET_FLEETS', fleets: selected });
  };
  ctrl.selectTrain = async (selected) => {
    ctrl.selectedFilters.trains = selected;
    setAndFetch({ type: 'SET_TRAINS', trains: selected });
  };
  ctrl.updateSelectedTime = async () => {
    const { startDate, endDate } = ctrl.dates;
    if (env.profile === 'QR') {
      // Local times are converted to 'fake UTC in ISO format' (necessary for QR where RMM data in db is in UTC+10)
      this.webtipMachine.send({ type: 'SET_DATES', 
                                startDate: DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd'T'HH:mm:ss.'000Z'"),
                                endDate: DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd'T'HH:mm:ss.'000Z'") 
                              });
    } else {
      this.webtipMachine.send({ type: 'SET_DATES', 
                                startDate: DateTime.fromJSDate(startDate).toUTC().toISO(),
                                endDate: DateTime.fromJSDate(endDate).toUTC().toISO() });
    }
    this.webtipMachine.send('FETCH_TRAINS');
    ctrl.datesChanged = false;
  };

  ctrl.updateDates = (startDate, endDate) => {
    ctrl.dates.startDate = startDate;
    ctrl.dates.endDateDate = endDate;
  }


  ctrl.resetSelected = async () => {
    _.each(ctrl.selectedFilters, (_, key) => {
      ctrl.selectedFilters[key] = [];
    });
    this.webtipMachine.send({ type: 'SET_SIGNALS', signalNames: [] });
    this.webtipMachine.send('RESET_FILTERS');
    this.webtipMachine.send('FETCH_TRAINS');
  };
}

angular
  .module('webtip.module')
  .controller('WebtipMainViewController', WebtipMainViewController);